import React from 'react'
import PropTypes from "prop-types";
import {connect} from 'react-redux'
// nodejs library that concatenates classes
import classNames from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import notificationStyle from 'assets/jss/material-dashboard-pro-react/views/notification'


//Compoernents
import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";
import AddAlert from "@material-ui/icons/AddAlert";
import Done from "@material-ui/icons/Done";
import Warning from "@material-ui/icons/Warning";
import Error from "@material-ui/icons/Error";
import NotificationImportant from "@material-ui/icons/NotificationImportant";


//actions
import {removeNotification} from 'actions/notification'

const customStyles = {
  closeBtn: {
    position: 'absolute',
    right: '10px',
    top: '5px'
  }
}

const Notification= (props)=>{
    let {classes,position,list,remove}=props;
    if(!position)position='tr'
    position = list[0] ? list[0].position : position
    const notificationClasses = classNames({
      [classes.Notification]:true,
      [classes[position]]:true,
    })
    // by default possition is top-right
    return <div className={notificationClasses}>
    {list.map((e,i)=>{
      let icon='';
      switch (e.type) {
        case 'info':    icon=NotificationImportant;   break;
        case 'success': icon=Done;                    break;
        case 'warning': icon=Warning;                 break;
        case 'danger':  icon=Error;                   break;
        case 'primary': icon=AddAlert;                break;
        default:        icon=AddAlert;                break;
      }
      return <SnackbarContent
                  key={i}
                  /*classes= {{closeBtn: classes.closeBtn}}*/
                  message={e.text}
                  position={e.position}
                  close
                  icon={icon}
                  color={e.type}
                  onClick={()=>remove(i)}
                />
    })}
    </div>
}

Notification.propTypes = {
  classes: PropTypes.object.isRequired,
  position: PropTypes.oneOf([
    'tl', //top-left
    'tm', //top-middle
    'tr', //top-right
    'bl', //bottom-left
    'bm', //bottom-middle
    'br', //bottom-rigth
  ]),
};
const state=(state)=>({
  list:state.notification
})
const dispatch=(dispatch)=>({
  remove:(i)=>dispatch(removeNotification(i)),
})
export default withStyles({...notificationStyle, ...customStyles})(connect(state,dispatch)(Notification))



// WEBPACK FOOTER //
// ./src/views/Notification/Notification.jsx